import React from 'react'
import Seo from './common/Seo';
import Hero from './home/Hero';
import FeatureSection from './home/FeatureSection';
import FeatureGrid from './home/FeatureGrid';
import VideoShowcase from './home/VideoShowcase';
import ManufacturingInnovation from './home/ManufacturingInnovation';
import ImgBanner from './home/ImgBanner';

const Home = () => {
    return (
        <>
            <Seo
              title="AI기반 스마트 제조 솔루션"
              description="MTST는 데이터와 AI로 제조 현장의 생산성과 품질을 혁신하는 MES·스마트공장 솔루션 기업입니다."
              path="/"
            />
            <VideoShowcase/>
            <Hero/>
            <FeatureSection/>
            <FeatureGrid/>
            <ManufacturingInnovation/>
            <ImgBanner/>
        </>
    );
}

export default Home